import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  TemplateRef,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { SpeakAction } from '../../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../../pipes/highlight-variables.pipe';
import { TtsPlayerService } from '../../../../../services/tts-player.service';

@Component({
  selector: 'app-speak-action',
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip,
    CdkDragHandle,
    NgTemplateOutlet,
    HighlightVariablesPipe,
  ],
  templateUrl: './speak-action.component.html',
  styleUrl: './speak-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpeakActionComponent {
  private readonly _ttsPlayer = inject(TtsPlayerService);

  public readonly data = input.required<SpeakAction>();
  public readonly actions = input<TemplateRef<unknown>>();

  protected readonly isTtsPlaying = computed(
    () =>
      this._ttsPlayer.isPlaying() && this._ttsPlayer.currentTtsId() === this.data()._id
  );

  protected handleTtsPlayback(): void {
    this._ttsPlayer.play(this.data().value, this.data()._id);
  }
}
